import { Component, Input, OnInit } from '@angular/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer'

@Component({
  selector: 'app-search-preview',
  standalone: true,
  imports: [NgxDocViewerModule],
  templateUrl: './search-preview.component.html',
  styleUrls: ['./search-preview.component.scss']
})
export class SearchPreviewComponent implements OnInit {
  urlViewer: string = "https://docs.google.com/gview?url=%URL%&embedded=true";
  @Input() urlDoc: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
